<template>
    <div>
        <h3 class="mt-0 mb-4">{{ title }}</h3>
        <div class="trax-struct" v-show="loaded">
            <div :id="id+'-struct'" class="trax-struct-body">
                <div class="trax-block trax-level-1 trax-actions-2" v-for="(typeName, typeCode) in itemTypes" :key="typeCode">

                    <button class="btn btn-link btn-just-icon btn-sm float-left trax-help"
                        @click="showGuide($event, typeCode)" v-if="items[typeCode] && (behaviouralIndicatorsIndexId || generalCriteriasIndexId)">
                            <i class="material-icons">help_outline</i>
                    </button>

                    <div class="trax-block-header">
                        <h4>{{ typeName }}</h4>
                    </div>

                    <div :id="id+'-struct-'+typeCode" class="trax-block-body" v-if="items[typeCode]">
                        <div :class="itemClass(item)" v-for="item in items[typeCode]" :key="item.id"  :data-id="item.id">
                            
                            <div class="btn btn-link btn-just-icon btn-sm trax-drag-handler move-2 float-right" v-if="drag">
                                <i class="material-icons">drag_indicator</i>
                            </div>

                            <div class="trax-bullet" v-if="!item.title">
                                <i class="material-icons">navigate_next</i>
                            </div>

                            <trax-ui-struct-actions :bus="bus" :id="id" :data="item"></trax-ui-struct-actions>

                            <p :class="itemContentClass(item)">{{ item.name }}</p>
                        </div>
                    </div>

                    <div class="trax-block-footer">
                        <button class="btn btn-sm btn-primary" @click="addItem($event, typeCode)">
                            {{ newItemLabel }}
                        </button>

                        <button class="btn btn-sm btn-default" @click="addTitle($event, typeCode)">
                            {{ newTitleLabel }}
                        </button>

                        <button class="btn btn-sm btn-secondary" @click="setBehaviouralIndicators($event, typeCode)" v-if="behaviouralIndicatorsIndexId">
                            {{ lang.polaris.common.behavioural_indicators }}
                        </button>

                        <button class="btn btn-sm btn-secondary" @click="setGeneralCriterias($event, typeCode)" v-if="generalCriteriasIndexId">
                            {{ lang.polaris.common.general_criterias }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        props: {
            bus: null,
            id: null,
            toastrId: {default: 'enac-custom-atpl-assessment-toastr'},
            behavioural_indicator_id: {default: 'enac-custom-atpl-assessment-behavioural-indicator-index'},
            general_criteria_id: {default: 'enac-custom-atpl-assessment-general-criteria-index'},
            assessment_guide_id: {default: 'enac-custom-atpl-assessment-assessment-guide'},
            generalCriteriasIndexId: null,
            behaviouralIndicatorsIndexId: null,
            drag: null,
            endpoint: null,
            endpointParams: null,
            newTitleLabel: {default: lang.polaris.training.new_competency_title},
            newItemLabel: {default: lang.polaris.form.new_item},
            itemTypesData: null,
            title: null,
            assessmentType: null,
            learningUnitId: null,
        },

        data: function() {
            return {
                lang: lang,
                loaded: false,
                flight_phases_names: data.flight_phases_names,
                competency_domains_names: data.competency_domains_names,
                items: {}
            }
        },

        created: function() {
            this.bus.$on(this.id+'-delete-confirmed', this.deleteItem);
            this.bus.$on(this.id+'-edit-created', this.refresh);
            this.bus.$on(this.id+'-edit-updated', this.refresh);
            this.getData();
        },

        computed: {

            itemTypes: function() {
                return this[this.itemTypesData];
            }
        },

        updated: function () {
            this.initDrag();
        },

        methods: {

            itemClass(item) {
                var res = 'trax-block trax-level-2 trax-actions-2';
                if (item.title) res += ' trax-title';
                return res;
            },

            itemContentClass(item) {
                return item.title ? '' : 'trax-with-bullet';
            },

            initDrag() {
                if (!this.drag) return;
                for (var typeCode in this.items) {
                    var el = document.getElementById(this.id+'-struct-'+typeCode);
                    Sortable.create(el, { handle: '.move-2', animation: 150, onUpdate: this.sorted });
                }
            },
            
            sorted(event) {
                var data = {id: event.item.dataset.id, order: event.newIndex };
                this.bus.$emit(this.id+'-edit-sorted', data);
            },

            addItem(event, typeCode) {
                var data = {assessment_type: this.assessmentType, learning_unit_id: this.learningUnitId, item_type: typeCode };
                this.bus.$emit(this.id+'-edit-create', data);
                this.bus.$emit(this.id+'-edit-open', {title: this.newItemLabel} );
            },

            addTitle(event, typeCode) {
                var data = {assessment_type: this.assessmentType, learning_unit_id: this.learningUnitId, item_type: typeCode, title: true };
                this.bus.$emit(this.id+'-edit-create', data);
                this.bus.$emit(this.id+'-edit-open', {title: this.newTitleLabel} );
            },

            setBehaviouralIndicators(event, typeCode) {
                var settings = {assessment_type: this.assessmentType, learning_unit_id: this.learningUnitId, item_type: typeCode };
                this.bus.$emit(this.behavioural_indicator_id+'-load-relations', settings);
                this.bus.$emit(this.behavioural_indicator_id+'-open' );
            },

            setGeneralCriterias(event, typeCode) {
                var settings = {assessment_type: this.assessmentType, learning_unit_id: this.learningUnitId, item_type: typeCode };
                this.bus.$emit(this.general_criteria_id+'-load-relations', settings);
                this.bus.$emit(this.general_criteria_id+'-open' );
            },
            
            showGuide(event, typeCode) {
                var settings = {assessment_type: this.assessmentType, learning_unit_id: this.learningUnitId, item_type: typeCode };
                this.bus.$emit(this.assessment_guide_id+'-load-guide', settings);
                this.bus.$emit(this.assessment_guide_id+'-open', {title: this.itemTypes[typeCode]});
            },

            getData() {
                var that = this;
                axios.get(this.endpoint, {params: this.endpointParams})
                    .then(function (response) {
                        that.items = {};
                        for (var index in response.data.data) {
                            var item = response.data.data[index];
                            if (that.items[item.item_type] == undefined) that.items[item.item_type] = [];
                            that.items[item.item_type].push(item);
                        }
                        that.loaded = true;
                    })
                    .catch(function (error) {
                    });
            },

            deleteItem(item) {
                var that = this;
                axios.delete(this.endpoint+'/'+item.id)
                    .then(function (response) {
                        that.refresh();
                    })
                    .catch(function (error) {
                        that.bus.$emit(that.toastrId+'-error', error.response.data);
                    });
            },

            refresh() {
                this.getData();
            }
        }
    }
</script>
